import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { ComplianceAppDataProviderFactory } from '../factory/ComplianceAppDataProviderFactory';
import { ComplianceAppBaseDataProvider } from '../dataProvider/ComplianceAppBaseDataProvider';
import { ComplianceAppWebComponentSchema } from '../types';
import {
  GetDashboardDataResponse,
  GenericComplianceDataRequest,
  GetControlAssetsRequest,
  GetControlIdentitiesResponse,
  GetControlResourcesResponse,
  GetRisksRequest,
  GetRisksResponse,
} from '@nirvana/shared/dtos/types/compliance-reports/gz-console';

export class ComplianceAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ComplianceAppDataProviderFactory;
  public dataProvider: ComplianceAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new ComplianceAppDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<ComplianceAppWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }

  async getMisconfigurations(params: GetRisksRequest): Promise<GetRisksResponse> {
    return this.dataProvider.getMisconfigurations(params);
  }

  async getUserBehaviorRisks(params: GetRisksRequest): Promise<GetRisksResponse> {
    return this.dataProvider.getUserBehaviorRisks(params);
  }

  async getControlResources(params: GetControlAssetsRequest): Promise<GetControlResourcesResponse> {
    return this.dataProvider.getControlResources(params);
  }

  async getControlIdentities(params: GetControlAssetsRequest): Promise<GetControlIdentitiesResponse> {
    return await this.dataProvider.getControlIdentities(params);
  }

  async generatePdf(params: GenericComplianceDataRequest): Promise<any> {
    return this.dataProvider.generatePdf(params);
  }

  async generateXlsx(params: GenericComplianceDataRequest): Promise<any> {
    return this.dataProvider.generateXlsx(params);
  }

  async getDashboardData(params: GenericComplianceDataRequest): Promise<GetDashboardDataResponse> {
    return this.dependencies.api.clients.ComplianceReports.getDashboardData(params).toPromise();
  }
}
